import { ACQUIRING_TYPES } from './AcquiringField.js';
import { FEEDBACK_METHOD, FEEDBACK_TYPES, SERVICE_DIRECTIONS, SERVICE_TYPES } from './constants.js';
import { VED_TYPES } from './VedField.js';
const initialFormState = {
    typeForm: '',
    region: { key: '', text: '' },
    addressBranch: { key: '', text: '' },
    surname: '',
    name: '',
    phone: '',
    secondaryPhone: '',
    comment: '',
    product: '',
    partnerComments: '',
    annualRevenue: '',
    term: 12,
    amount: 100000,
    acquiringType: ACQUIRING_TYPES[0],
    serviceType: SERVICE_TYPES[0],
    feedbackType: FEEDBACK_TYPES[0],
    feedbackMethod: FEEDBACK_METHOD[0],
    serviceDirection: SERVICE_DIRECTIONS[0],
    vedTypes: VED_TYPES[0],
    birthday: undefined,
    isClient: false,
    onlineCheckout: false,
    posTerminal: false,
    consentToReceiveMaterials: false,
    consentDataProcessing: false,
};
export const getInitialFormState = (inputs, typeForm = '') => {
    const formState = Object.fromEntries(inputs.map((_) => [
        _.name,
        (_.fieldType === 'ved' && _?.defaultValue) || initialFormState[_.name],
    ]));
    if (formState?.serviceType && typeForm === 'PREMIUMSERVICE') {
        formState.serviceType = SERVICE_TYPES[1];
    }
    return { ...formState, typeForm: { key: '' || typeForm, text: '' } };
};
//# sourceMappingURL=getInitialFormState.js.map